import { Controller } from "@hotwired/stimulus"

// Feature-usage tracker (admin-only heatmap). Delegated click listener:
// on any click inside a real Stimulus feature ([data-controller]), read
// the stable data-issue-id (issue_tag.js) and bucket it by its
// "section.controller" prefix. Counts are batched locally and flushed to
// /activity/features every FLUSH_MS + when the tab is hidden/closed.
//
// We capture ONLY the structural id (which control) -- never the element's
// text or value -- so no user content / PHI ever leaves the browser.
const FLUSH_MS = 30000
const KEY_RE   = /^[\w-]+\.[\w-]+$/

export default class extends Controller {
  connect() {
    this.counts = new Map()
    this.token  = document.querySelector('meta[name="csrf-token"]')?.content || ""

    this.onClick = (e) => this.track(e)
    document.addEventListener("click", this.onClick, true)

    this.onHide = () => { if (document.visibilityState === "hidden") this.flush() }
    document.addEventListener("visibilitychange", this.onHide)
    this.onPageHide = () => this.flush()
    window.addEventListener("pagehide", this.onPageHide)

    this.timer = setInterval(() => this.flush(), FLUSH_MS)
  }

  disconnect() {
    document.removeEventListener("click", this.onClick, true)
    document.removeEventListener("visibilitychange", this.onHide)
    window.removeEventListener("pagehide", this.onPageHide)
    if (this.timer) clearInterval(this.timer)
    this.flush()
  }

  track(e) {
    const el = e.target?.closest?.("[data-issue-id]")
    if (!el || !el.closest("[data-controller]")) return   // real features only
    const parts = (el.dataset.issueId || "").split(".")
    if (parts.length < 2) return
    const feature = `${parts[0]}.${parts[1]}`
    if (!KEY_RE.test(feature)) return
    this.counts.set(feature, (this.counts.get(feature) || 0) + 1)
  }

  flush() {
    if (!this.counts || this.counts.size === 0) return
    const features = {}
    this.counts.forEach((v, k) => { features[k] = v })
    this.counts.clear()
    try {
      fetch("/activity/features", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.token,
          "Accept": "application/json"
        },
        credentials: "same-origin",
        keepalive: true,
        body: JSON.stringify({ features })
      }).catch(() => {})
    } catch (_) { /* never let tracking break the page */ }
  }
}
